export default {"src":"/planos/_next/static/media/equifax-phone-chat.ee9dbc76.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};